import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addLookup } from "../../redux/lookupSlice";
import { onUpdate, setSurvey } from "../../redux/surveySlice";
import { api } from "../../services/api-service";
import Input from "../layouts/Input";

const SurveyForm = () => {
  const dispatch = useDispatch();
  const [fields, setFields] = useState([]);

  useEffect(() => {
    getFields();
  }, []);

  const getFields = async () => {
    const response = await api.get("get-fields?type=surveyor");
    if (response && response.ok) {
      setFields(
        response.data.data.map((field) => {
          const fieldType =
            field.name === "currentUse" ? "text" : field.type;

          return {
            ...field,
            type: fieldType,
            handleChange: (val) => handleChange(field.name, val),
            options:
              fieldType === "select" ? getLookup(field.name) : undefined,
          };
        })
      );
    }
  };

  const getLookup = async (field) => {
    if (field === "tenure" || field === "locality") {
      const response = await api.get(`lookup?type=${field}`);
      if (response && response.ok) {
        const data = response.data.data.map((data) => {
          return { ...data, label: data.id, value: data.id };
        });
        dispatch(addLookup({ type: field, value: data }));
        return data;
      }
    }
  };

  const handleChange = (field, value) => {
    dispatch(setSurvey({ field, value }));
    dispatch(onUpdate());
  };

  return (
    <>
      {fields &&
        fields.map((field) => (
          <Input field={field} key={field.id} />
        ))}
    </>
  );
};

export default SurveyForm;
